import React from 'react'
import { withPrefix } from 'gatsby'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import theme from '../../src/theme'
// import Loading from '../../src/components/Loading'
import { CssBaseline } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import { RecoilRoot } from 'recoil'

export default function TopLayout (props) {
  return (
    <React.Fragment>
      <RecoilRoot>
      {/* <Helmet>
        <meta name="viewport" content="minimum-scale=1, initial-scale=1, width=device-width" />
        <link href={withPrefix('eventLog.css')} rel="stylesheet" type="text/css" />
      </Helmet> */}
      <ThemeProvider theme={theme}>
        {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
        <CssBaseline />
        {/* <Loading> */}
          {props.children}
        {/* </Loading> */}
      </ThemeProvider>
      </RecoilRoot>
    </React.Fragment>
  )
}

TopLayout.propTypes = {
  children: PropTypes.node
}
